<template>
  <RouterLink :to="`/astronomers/${astronomerSlug}/targets/${target.id}`" class="block">
    <div class="break-inside rounded-md bg-gray-600 p-4 text-center mb-4">
      <h3 class="text-yellow-300" :title="target.name">
        {{ truncate(target.name, 30) }}
      </h3>

      <img
        v-if="target.image_url"
        :src="target.image_url"
        :alt="target.name"
        class="mx-auto"
      />
      <img
        v-else-if="target.last_image_thumbnail"
        :src="`data:image/jpeg;base64, ${target.last_image_thumbnail}`"
        :alt="target.name"
        class="mx-auto"
      />

      <span class="text-xs">
        <template v-if="target.last_image_captured_at">
          {{ timeAgo(target.last_image_captured_at) }} ago
        </template>
        <template v-if="target.last_image_captured_at && target.total_duration"> | </template>
        <template v-if="target.total_duration">
          {{ target.total_duration.toLocaleString() }}
          {{ target.total_duration === 1 ? 'hour' : 'hours' }}
        </template>
      </span>
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { timeAgo } from '../utils/timeAgo'

interface Target {
  id: number
  name: string
  image_url: string | null
  last_image_thumbnail: string | null
  last_image_captured_at: string | null
  total_duration: number | null
  complete: boolean
}

defineProps<{
  target: Target
  astronomerSlug: string
}>()

function truncate(s: string, n: number): string {
  return s.length > n ? s.slice(0, n) + '...' : s
}
</script>
